import React, { FC, useState, useEffect } from "react";
import FalconTitle from "../FalconTitle/FalconTitle";
import FalconDescription from "../FalconDescription/FalconDescription";
import "./OverlayModal.css";
import { CloseButton, Modal } from "react-bootstrap";

interface OverLayModalSchema {
  children: React.ReactNode;
  modalState: boolean;
  handler: () => void;
  noCloseButton?: boolean;
  showBackBtn?: boolean;
  overlay?: any;
}

const OverLayModal: React.FC<OverLayModalSchema> = ({
  children,
  modalState,
  handler,
  noCloseButton,
  showBackBtn,
  overlay,
}) => {
  const [title, setTitle] = useState<any>();
  const [footer, setFooter] = useState<any>();
  useEffect(() => {
    overlay.map((m: any) => {
      m?.content?.body.map((b: any) => {
        if (b?.component == "falconTitle") {
          setTitle(b);
        }
        if (b?.component == "falconDescription") {
          setFooter(b);
        }
      });
    });
  }, [overlay]);

  return (
    <>
      <Modal
        centered
        show={modalState}
        onHide={handler}
        keyboard={false}
        dialogClassName="linetable-country-overlayModal"
      >
        <Modal.Header>
          <div style={{ display: noCloseButton ? "none" : "" }}>
            <div className="d-flex align-items-center">
              {showBackBtn && (
                <div
                  className="me-sm-4 me-3 d-flex align-items-center"
                  onClick={handler}
                >
                  <img src="../../icons/left_arrow.svg" alt='arrow'></img>
                </div>
              )}
              {title && <FalconTitle content={title} />}
            </div>
          </div>
          <div style={{ display: noCloseButton ? "none" : "" }}>
            <CloseButton className="sr-modal-close" onClick={handler} />
          </div>
        </Modal.Header>

        <Modal.Body>{children}</Modal.Body>

        <Modal.Footer>
          {footer && <FalconDescription content={footer} />}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default OverLayModal;
